import { type FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";
import { formatNumberByThousands } from "widgets/utils";

import { pluralizeWord } from "../../../app-utils/string.js";
import {
  type Protein,
  type ProteinLocation,
  type Region,
  type Transcript,
  type TranscriptLocation,
} from "../../../graphql.js";
import { GenomeViewTile } from "../../core/tiles/index.js";

export interface ILocationCardProps extends GridCard {
  transcript?: Transcript;
  protein?: Protein;
}

const LocationCard: FC<ILocationCardProps> = (props) => {
  const transcriptLocations: TranscriptLocation[] = props.transcript?.transcriptLocations;
  const proteinLocations: ProteinLocation[] = props.protein?.proteinLocations;
  const locations = transcriptLocations ?? proteinLocations ?? [];

  return (
    <Card key="location-info-card" title="Location">
      <CardRowSimple>
        {locations.length === 0
          ? "There are no locations"
          : locations.map((location, index: number) => {
              const region: Region = location.region;
              const startFormatted = formatNumberByThousands(region.range.start);
              const stopFormatted = formatNumberByThousands(region.range.stop);
              const length = props.transcript
                ? location.transcriptMappings?.length
                : (location as ProteinLocation).proteinLocationMappings?.length;
              const baseLink = props.transcript ? `/transcript/${props.transcript.id}` : `/protein/${props.protein.id}`;
              return (
                // TODO Range is not mandatory and the GenomeView of an entity is automatically set.
                <GenomeViewTile
                  title={region.contig.sequenceId}
                  footNote={`${formatNumberByThousands(region.range.stop - region.range.start + 1)} bp. ${
                    region.contig?.name ?? ""
                  }`}
                  to={`${baseLink}/genome?contig=${region.contig.id}&range=${region.range.start},${region.range.stop}`}
                  key={"tcp-location-location-elem-" + index}
                >
                  {startFormatted} &ndash; {stopFormatted} ({region.strand}), {length} {pluralizeWord("exon", length)}
                </GenomeViewTile>
              );
            })}
      </CardRowSimple>
    </Card>
  );
};

export { LocationCard };
